import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowLeft = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 13,
	height: 11,
	viewBox: "0 0 13 11",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M6.47568 8.99953L3.75559 6.19653L12.5 6.19653V4.19653L3.75559 4.19653L6.47568 1.39453L5.04274 -0.000469208L0 5.19653L5.04274 10.3945L6.47568 8.99953Z",
		fill: "#005AA0"
	})]
});
const ForwardRef = forwardRef(SvgArrowLeft);
export { ForwardRef as ReactComponent };
